import { Link } from '@chakra-ui/react'
import NextLink from 'next/link'
import { getAlertLink } from '@/utils/reports/report_utils'
import { DOPPEL_LINK } from '@/utils/style'

type AlertIdLinkProps = {
  // The external alert ID (e.g. TET-1234)
  alertId: string
  // The text color; defaults to DOPPEL_LINK but may need to change based on context
  color?: string
  // Normal, bold, etc; defaults to none (inherit)
  fontWeight?: string
}

const AlertIdLink = ({
  alertId,
  color = DOPPEL_LINK,
  fontWeight,
}: AlertIdLinkProps) => {
  return (
    <Link
      as={NextLink}
      color={color}
      fontWeight={fontWeight}
      href={getAlertLink(alertId)}
      noOfLines={1}
      textDecoration="underline"
      whiteSpace="nowrap"
    >
      {alertId}
    </Link>
  )
}

export default AlertIdLink
